import useSWR from 'swr';
import useSWRMutation from 'swr/mutation';
import { InfiniteScrollGridResponse, ReviewLogLookupDto, SuccessResponse } from '@interfaces/central-monitoring';
import { ObservationType } from '@interfaces-clean/observations.interface';
import {
    BulkUpdateControlsReviewLog,
    CreateControlsReviewLog,
    DeleteControlsReviewLog,
    UpdateControlsReviewLog,
} from '@interfaces-clean/review-logs.interface';

import { getData, postData } from '@apis/rest-client';

const controlsReviewLogUrl = 'CentralMonitoring/ControlsReviewLog';

const ControlsReviewLogsApi = {
    useSave: (studyRef: string) => {
        return useSWRMutation(
            `${controlsReviewLogUrl}/Add/${studyRef}`,
            (url: string, { arg }: { arg: CreateControlsReviewLog }) => {
                return postData<CreateControlsReviewLog, SuccessResponse>(url, { arg, timeout: 30000 });
            },
        );
    },
    useUpdate: (studyRef: string) => {
        return useSWRMutation(
            `${controlsReviewLogUrl}/Update/${studyRef}`,
            (url: string, { arg }: { arg: UpdateControlsReviewLog }) => {
                return postData<UpdateControlsReviewLog, SuccessResponse>(url, { arg, timeout: 30000 });
            },
        );
    },
    useDelete: (studyRef: string) => {
        return useSWRMutation(
            `${controlsReviewLogUrl}/Delete/${studyRef}`,
            (url: string, { arg }: { arg: DeleteControlsReviewLog }) => {
                return postData<DeleteControlsReviewLog, boolean>(url, { arg, timeout: 30000 });
            },
        );
    },
    useBulkUpdate: (studyRef: string) => {
        return useSWRMutation(
            `${controlsReviewLogUrl}/bulkUpdate/${studyRef}`,
            (url: string, { arg }: { arg: BulkUpdateControlsReviewLog }) => {
                return postData<BulkUpdateControlsReviewLog, boolean>(url, { arg, timeout: 30000 });
            },
        );
    },
    useGet: (studyRef: string, id: string) => {
        return useSWR(`${controlsReviewLogUrl}/${studyRef}/${id}`, (url: string) => {
            return getData<InfiniteScrollGridResponse>(url, { timeout: 30000 });
        });
    },
    useGetMutation: (studyRef: string) => {
        // extra arg is for review log id - ensures it isn't stale data
        return useSWRMutation(`${controlsReviewLogUrl}/${studyRef}`, (url: string, { arg }: { arg: string }) => {
            return getData<InfiniteScrollGridResponse>(`${url}/${arg}`, { timeout: 30000 });
        });
    },

    useLookupReviewLogsForObservation: (studyRef: string, observationId: string, observationType: ObservationType) => {
        const url =
            observationType === ObservationType.Controls
                ? `${controlsReviewLogUrl}/Get/${studyRef}/ReviewLogsForObservation/${observationId}`
                : null;

        return useSWR<ReviewLogLookupDto[]>(url, getData);
    },
};

export default ControlsReviewLogsApi;
